import { campoDeveEstarEntreValor1eValor2, campoDeveSerMaiorQueZero, campoObrigatorio } from 'helpers/Constantes/Mensagens'

export type DadosConstrucao = {
  custoCasa: string
  colchaoLancamento: string
  duracaoObra: string
  prazoTotalVendas: string
  valido: boolean
}

export const dadosConstrucaoValorDefault = {
  custoCasa: '',
  colchaoLancamento: '',
  duracaoObra: '',
  prazoTotalVendas: ''
} as DadosConstrucao

export class ValidacaoDadosConstrucao {
  custoCasa: string
  colchaoLancamento: string
  duracaoObra: string
  prazoTotalVendas: string

  constructor(custoCasa = '', colchaoLancamento = '', duracaoObra = '', prazoTotalVendas = '') {
    this.custoCasa = custoCasa
    this.colchaoLancamento = colchaoLancamento
    this.duracaoObra = duracaoObra
    this.prazoTotalVendas = prazoTotalVendas
  }

  validarInputUsuario(inputUsuario: string): string {
    let error = ''

    if (parseInt(inputUsuario) === 0) error = campoDeveSerMaiorQueZero

    if (inputUsuario === '') error = campoObrigatorio

    return error
  }

  validarTodosCampos(state: DadosConstrucao): boolean {
    if (
      state.custoCasa != '' &&
      this.custoCasa === '' &&
      state.colchaoLancamento != '' &&
      this.colchaoLancamento === '' &&
      state.duracaoObra != '' &&
      this.duracaoObra === '' &&
      state.prazoTotalVendas != '' &&
      this.prazoTotalVendas === ''
    ) {
      return true
    }
    return false
  }

  validarValorMinMax(inputValor: string, valorMin: number, valorMax: number): string {
    if (inputValor === '') return campoObrigatorio

    if (parseInt(inputValor) < valorMin || parseInt(inputValor) > valorMax) return `${campoDeveEstarEntreValor1eValor2(valorMin, valorMax)} meses.`

    return ''
  }

  validarDuracaoObra(inputDuracaoObra: string): string {
    return this.validarValorMinMax(inputDuracaoObra, 9, 24)
  }

  validarColchaoLancamento(inputColchaoLancamento: string): string {
    return this.validarValorMinMax(inputColchaoLancamento, 1, 12)
  }

  validarPrazoTotalVendas(inputPrazoTotalVendas: string): string {
    return this.validarValorMinMax(inputPrazoTotalVendas, 1, 36)
  }
}
